<template>
	<div>
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<div v-on="on">
					<v-btn
						icon
						color="white"
						@click.stop="onClick"
					>
						<v-icon>
							{{ states[index].icon }}
						</v-icon>
					</v-btn>
				</div>
			</template>
			{{ states[index].tooltip }}
		</v-tooltip>
	</div>
</template>

<script>
export default {
	name: 'ScopeButton',
	data: function() {
		return {
			index: 0,
			states: [{
				value: 'own',
				icon: 'mdi-account',
				tooltip: 'Search in my boxes'
			}, {
				value: 'friends',
				icon: 'mdi-account-group-outline',
				tooltip: 'Search in friends boxes'
			}, {
				value: 'all',
				icon: 'mdi-account-group',
				tooltip: 'Search in all visible boxes'
			}]
		}
	},
	methods: {
		onClick: function() {
			this.index = (this.index + 1) % this.states.length
			this.$emit('input', this.states[this.index].value)
		}
	}
}
</script>
